import { render, staticRenderFns } from "./_base-input-date.vue?vue&type=template&id=1f3dda58&scoped=true"
import script from "./_base-input-date.vue?vue&type=script&lang=js"
export * from "./_base-input-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3dda58",
  null
  
)

export default component.exports